import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getLoginData, loginUser } from "../../api/user/login-page";
import { DISPLAY_LANG } from "../../config";
import Loading from "../../components/loading";
import "../../stylesheets/user/login.css";

export default function LoginPage() {
  const [loading, setLoading] = useState(true);
  const [loginData, setLoginData] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    passwd: "",
  });

  useEffect(() => {
    const loadingData = async () => {
      try {
        const data = await getLoginData();
        setLoginData(data);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
    loadingData();
    window.scrollTo(0, 0);
  }, []);

  const onChangeInput = (target) => {
    setFormData({ ...formData, [target.name]: target.value });
  };

  const submitHendler = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await loginUser(formData);

      if (res.ok) {
        localStorage.setItem('reseller_customer_id', res.reseller_customer_id);
        localStorage.setItem('token', res.token);
        localStorage.setItem('user_id', res.user_id);

        const SELECTED_HOSTING_PLAN_NAME = sessionStorage.getItem('SELECTED_HOSTING_PLAN_NAME');
        const redirectAfterLogin = sessionStorage.getItem('redirectAfterLogin');

        if (SELECTED_HOSTING_PLAN_NAME) {
          window.location.href = `/hosting/${SELECTED_HOSTING_PLAN_NAME}`;
        } else if (redirectAfterLogin) {
          window.location.href = redirectAfterLogin;
        } else {
          window.location.href = '/user';
        }
      }

    } catch (error) {
      console.log(error);

      if (error.response.data.email) {
        alert(error.response.data.email[0]);
        setLoading(false);
        return;
      }

      if (error.response.data) {
        alert(error.response.data[DISPLAY_LANG][0]);
      }

      setLoading(false);
    } finally {
      sessionStorage.removeItem('redirectAfterLogin');
    }
  };

  if (loading) {
    return <Loading />
  }

  return loginData && (
    <div className="login_page wrapper">
      <div className="container">
        <div className="content">
          <h3 className="title">{loginData.title}</h3>
          <p className="subtitle">{loginData.subtitle}</p>
        </div>

        <div className="register_login">
          <Link to="/user/register" className="reg_log">
            {loginData.register_btn_text}
          </Link>
          <Link to="/user/login" className="reg_log active">
            {loginData.log_in_btn_text}
          </Link>
        </div>

        <form onSubmit={submitHendler}>
          <label className="form_label" htmlFor="email">
            {loginData.label_email}
          </label>

          <input
            name="email"
            type="email"
            id="email"
            required="required"
            value={formData.email}
            onChange={(e) => onChangeInput(e.target)}
          />

          <label className="form_label" htmlFor="pass">
            {loginData.label_password}
          </label>

          <div className="eye-label">
            <input
              name="passwd"
              type={showPassword ? "text" : 'password'}
              id="pass"
              required="required"
              value={formData.passwd}
              onChange={(e) => onChangeInput(e.target)}
            />

            <span
              className="toggle_pass"
              onClick={() => setShowPassword(!showPassword)}
            >
              <img
                src={
                  showPassword
                    ? "/images/users/eye-regular-full.svg"
                    : "/images/users/eye-slash-regular-full.svg"
                }
                alt="toggle password"
                className="eye_icon"
              />
            </span>
          </div>


          <button type="submit" className="btn">
            {loginData.log_in_btn_text}
          </button>
        </form>

        <div className="social_register">
          <h3>{loginData.other_method_out_field}</h3>
          <div className="line"></div>
          <div className="socials">
            <div className="btn soc_icon">
              <Link to="/">
                <img src="/images/users/icon-facebook.svg" alt="social icon" />
              </Link>
            </div>

            <div className="btn soc_icon">
              <Link to="/">
                <img src="/images/users/icon-google.svg" alt="social icon" />
              </Link>
            </div>

            <div className="btn soc_icon">
              <Link to="/">
                <img src="/images/users/icon-apple.svg" alt="social icon" />
              </Link>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
